import React, { useState } from "react";
import Cta from "~components/Cta";
import ReceiverForm from "./components/ReceiverForm";
import "./style.scss";
import WalletLayout from "../components/WalletLayout";
import { useConfigureFooter } from "~hooks/useHelpers";

const Receiver = () => {
  const [backRoute, setBackRoute] = useState(null);

  useConfigureFooter({ form: true, backRoute, formId: "recebedor" }, [backRoute])

  return (
    <WalletLayout>
      <Cta title="Recebedor" />
      <ReceiverForm setBackRoute={setBackRoute} />
    </WalletLayout>
  );
};

export default Receiver;
